// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M18.4144 7.50003L13.9144 12L18.4144 16.5L17.0001 17.9142L11.0859 12L17.0002 6.08582L18.4144 7.50003ZM11.9144 7.50003L7.41436 12L11.9144 16.5L10.5002 17.9142L4.58594 12L10.5002 6.08582L11.9144 7.50003Z"}}]};

const ChevronLeftDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-left-double',
    ref,
    icon: element,
  },
));

ChevronLeftDoubleIcon.displayName = 'ChevronLeftDoubleIcon';

export default ChevronLeftDoubleIcon;
